export default __webpack_public_path__ + "images/City_skyline.svg";